import React, { createContext, useContext } from 'react';
import { node } from 'prop-types';
import GA from './services/googleAnalytic';
import YM from './services/yandexMetric';
import { sendEvent } from './sender';

var combineFuncs = function combineFuncs() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, data = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      data[_key2] = arguments[_key2];
    }

    return funcs.forEach(function (func) {
      return func.apply(void 0, data);
    });
  };
};

var value = {
  sendEvent: combineFuncs(YM(sendEvent), GA(sendEvent))
};
var Context = /*#__PURE__*/createContext(value);
export var AnalyticsContextProvider = function AnalyticsContextProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
};
export var useAnalyticsContext = function useAnalyticsContext() {
  var context = useContext(Context);

  if (context === undefined) {
    throw Error('useAnalyticsContextProvider must be used within a AnalyticsContextProvider');
  }

  return context;
};
AnalyticsContextProvider.propTypes = {
  children: node
};